import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { TextField } from "@mui/material";
import SelectRole from "./RoleSelect";
import { GlobalMessageContext } from "../app/App";
import ConfigData from "../config/config.json";

const webserver = ConfigData.WEBSERVER;

//const regex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"§#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])/gm;

export default function NewUser(props) {
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);

  const [setErrors] = React.useState({
    minLengthError: "",
    regexError: "",
    confirmationError: "",
    userExistsError: "",
  });
  const [saveDisabled, setSaveDisabled] = React.useState(true);

  const [userName, setUserName] = React.useState("");
  const [email, setEmail] = React.useState("");
  /* Change of Logic: password should not be set by creator
        const [password, setPassword] = React.useState('');
        const [confirmPassword, setConfirmPassword] = React.useState('');
    */

  const [role, setRole] = React.useState("EXAMINER");

  const clearForm = () => {
    setUserName("");
    setEmail(""); /*setPassword('');setConfirmPassword('')*/
    setRole("EXAMINER");
  };
  /*Change of Logic: password should not be set by creator
    useEffect(() => {
        const feedback = {
            minLengthError: '',
            regexError: '',
            confirmationError: '',
            userExistsError: ''
        };
        
        if (password.length < 8 && password.length > 0) {
            feedback.minLengthError = 'Minimale Passwortlänge: 8 Zeichen.';
        } else {
            feedback.minLengthError = '';
        }
        
        if (!regex.test(password) && password.length > 0) {
            feedback.regexError = 'Minimale Passwort-Komplexität: Mindestens je ein Groß-, Kleinbuchstabe, Sonderzeichen und eine Zahl.';
        } else {
            feedback.regexError = '';
        }

        if (password !== confirmPassword) {
            feedback.confirmationError = '"Passwort" und "Passwort bestätigen" müssen übereinstimmen.';
        } else {
            feedback.confirmationError = '';
        }
        setErrors(feedback);
    }, [password, confirmPassword]);
    */

  useEffect(() => {
    if (
      !(
        (
          userName === "" || email === ""
        ) /*|| password.length < 8 || !regex.test(password) || password !== confirmPassword*/
      )
    ) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  }, [userName, email /*, password, confirmPassword*/]);

  const handleSubmitNewUser = (e) => {
    const formData = { userName, email /*, password*/, role };

    e.preventDefault();
    setSaveDisabled(true);

    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/user/add",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(formData),
      }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unable to access endpoint: user/add");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data !== true) {
          setErrors({
            userExistsError: "Der Benutzername ist bereits vergeben.",
          });
        } else {
          clearForm();
          props.setRows((prev) =>
            prev.concat([{ userName: userName, email: email, role: role }])
          );
          setGlobalMessage({
            globalMessage: "Benutzer angelegt",
            severity: "success",
          });
        }
      })
      .catch((error) => {
        setGlobalMessage({
          globalMessage: "Vorgang fehlgeschlagen",
          severity: "error",
        });
      })
      .finally(() => setSaveDisabled(false));
  };

  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)}>
      <Box component="form" onSubmit={(e) => handleSubmitNewUser(e)}>
        <DialogTitle>Neues Benutzerkonto anlegen</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="newUserName"
            label="Benutzername"
            type="text"
            fullWidth
            variant="standard"
            required
            value={userName}
            onInput={(e) => {
              setUserName(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="newUserEmail"
            sx={{ marginBottom: 3.5 }}
            label="E-Mail Adresse"
            type="email"
            fullWidth
            variant="standard"
            required
            value={email}
            onInput={(e) => {
              setEmail(e.target.value);
            }}
          />
          {/* Change of Logic: password should not be set by creator
                    <TextField
                        
                        margin="dense"
                        id="newUserPassword"
                        label="Passwort"
                        type="password"
                        fullWidth
                        variant="standard"
                        required
                        value={password}
                        onInput={(e) => {setPassword(e.target.value)}}
                    />
                    <TextField sx={{marginBottom: 3}}                      
                        margin="dense"
                        id="newUserConfirmPassword"
                        label="Passwort bestätigen"
                        type="password"
                        fullWidth
                        variant="standard"
                        required
                        value={confirmPassword}
                        onInput={(e) => {setConfirmPassword(e.target.value)}}
                    />
                    */}
          {
            //TODO state management
          }
          <SelectRole role={role} setRole={setRole} />
          {/*
                    {(errors.minLengthError || errors.regexError || errors.confirmationError || errors.userExistsError) && 
                    <Alert sx={{ mt: 3 }} variant="outlined" severity="error">                        
                        <ul style={{margin: 0}}>
                            {errors.minLengthError && <li key='minLengthError'>{errors.minLengthError}</li>}
                            {errors.regexError && <li key='regexError'>{errors.regexError}</li>}
                            {errors.confirmationError && <li key='confirmationError'>{errors.confirmationError}</li>}
                            {errors.userExistsError && <li key='userExistsError'>{errors.userExistsError}</li>}
                        </ul>
                    </Alert>
                    
                    }   
                    */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.setOpen(false)}>Schließen</Button>
          <Button onClick={() => clearForm()}>Formular leeren</Button>
          <Button type="submit" disabled={saveDisabled}>
            Hinzufügen
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
